/**
 * The driver's own data outside coaching and comms: trips (the trips API scopes a driver to
 * their own rows) and driving hours left (tacho). Coaching, scores and messages use those
 * modules' hooks.
 */
import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from '@/lib/api/client';
import type { components } from '@/lib/api/schema';

export type TripOut = components['schemas']['TripOut'];
export type TachoHoursOut = components['schemas']['TachoHoursOut'];

export function useMyTrips(driverId: string | null | undefined, start: string, enabled = true) {
  return useQuery({
    queryKey: ['me', 'trips', driverId, start],
    queryFn: () => unwrap(api.GET('/api/trips', { params: { query: { driver: driverId ?? undefined, start, limit: 200 } } })),
    enabled: !!driverId && enabled,
  });
}

export function useMyHours(enabled = true) {
  return useQuery({
    queryKey: ['me', 'hours'],
    queryFn: () => unwrap(api.GET('/api/tacho/me/hours')),
    enabled,
    refetchInterval: 60_000,
    retry: false,
  });
}
